import { matchFaces } from '@vlabs/api/luna-api/client';
import type { FaceMatchResult, MatchFacesRequestJson, MatchResult } from '@vlabs/api/luna-api/model';
import { confirmAlert } from 'react-confirm-alert';

import { DuplicatedFaceConfirmation } from './DuplicatedFaceConfirmation';

export interface ConfirmDuplicateFaceProps extends MatchFacesRequestJson {
  referenceFaceSrc?: string;
  onConfirm?: VoidFunction;
  onReject?: VoidFunction;
}

export async function confirmDuplicateFace({
  referenceFaceSrc = undefined,
  references,
  candidates,
  onConfirm = undefined,
  onReject = undefined,
}: ConfirmDuplicateFaceProps): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const confirm = async () => {
      const matchFacesResp = await matchFaces({
        references,
        candidates,
      }, undefined, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if ((matchFacesResp as MatchResult).length < 1) {
        return;
      }

      const result = (matchFacesResp as MatchResult)[0];
      const match: FaceMatchResult = result?.matches?.[0] as FaceMatchResult;
      const $result = match?.result?.[0];

      if (!$result) {
        resolve();
        return;
      }

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <DuplicatedFaceConfirmation
              faceSrc={referenceFaceSrc}
              match={$result}
              onConfirm={() => {
                onConfirm?.();
                resolve();
                onClose();
              }}
              onReject={() => {
                onReject?.();
                reject();
                onClose();
              }}
            />
          );
        },
      });
    };

    confirm();
  });
}
